import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import { TootBreadcrumb } from "../../../../modules/navigation/components/TootBreadcrumb/TootBreadcrumb";
import type { IBreadcrumbBlockProps } from "./BreadcrumbBlock.props";

export const BreadcrumbBlock = ({ items, variant }: IBreadcrumbBlockProps) => {
  if (!items?.length) {
    return null;
  }

  return (
    <TootSectionShell spacing="tight" width={variant === "deep" ? "wide" : "default"}>
      <TootBreadcrumb items={items} variant={variant} />
    </TootSectionShell>
  );
};

BreadcrumbBlock.displayName = "Block::BreadcrumbBlock";
